<h1>{{ "TRAINER" | translate }}</h1>
<div class="row">
  <div class="col-md-12 col-lg-12">
    <trainer-table #emptable [employees]="employees$ | async" (employeeSelected)="openBottomSheet($event)" (addEmployeeClicked)="openBottomSheet()" (refresh)="fetchTrainer()"></trainer-table>
  </div>
</div>
